import {ID} from '../../../../../../_metronic/helpers'
import {Proposal} from '../../proposals/core/_models'

export interface ReceptionData {
  Proposta: ID
  id_documento: string
  id_caixa: string
}
export interface IReceptionCreate {
  protocol: string
  proposals: Proposal[]
  selectedProposals: ReceptionData[]
}

export const defaultReceptionCreate: IReceptionCreate = {
  protocol: '',
  proposals: [],
  selectedProposals: [],
}

export type StepProps = {
  data: IReceptionCreate
  updateData: (fieldsToUpdate: Partial<IReceptionCreate>) => void
  hasError: boolean
  errorMessage: string
  searchedProposals?: Proposal[]
}
